var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-wrapper container"},[_c('p',[_vm._v(" Al continuar, acepto los "),_c('a',{staticClass:"disable-selection",attrs:{"href":"#"}},[_vm._v("términos y condiciones")]),_vm._v(" sobre el tratamiento de datos. ")])])
}]

export { render, staticRenderFns }